import * as dateFormat from 'dateformat';
import { getI18n } from '../../src/services/i18n-service';
import { OperationItem } from '../../src/types/operation-item';
import { AuditLog } from '../../src/types/audit-log';
import { translations } from '../../src/types/translations';

const epochTime = 621355968000000000;

export function dateToTicks(date: Date): string {
  // getTime returns the numeric representation of the date as UTC
  return (date.getTime() * 10000 + epochTime).toString();
}

export function ticksToDate(ticks: number) {
  return new Date((ticks - epochTime) / 10000);
}

export const compareScanDatetime = (a: OperationItem, b: OperationItem) => {
  if (new Date(a.scanDatetime) > new Date(b.scanDatetime)) {
    return -1;
  }
  if (new Date(a.scanDatetime) < new Date(b.scanDatetime)) {
    return 1;
  }
  return 0;
};

export const getElapsedMsSinceRequestStarted = (
  item: OperationItem,
  timeStamp: Date
) => {
  const diffInMilliseconds =
    timeStamp.getTime() - new Date(item.serverRequestStarted).getTime();
  return diffInMilliseconds;
};

export const compareAuditTimeStamp = (a: AuditLog, b: AuditLog) => {
  const dateA = Number.parseInt(a.timestamp, 10);
  const dateB = Number.parseInt(b.timestamp, 10);
  if (dateA > dateB) {
    return -1;
  }
  if (dateA < dateB) {
    return 1;
  }
  return 0;
};

export const getCleanDateFromTicks = (ticks: string): string => {
  const date = ticksToDate(Number.parseInt(ticks, 10));
  const i18n = getI18n();
  return dateFormat(date, i18n.t(translations.CleanDateFormat));
};

export const getCleanDate = (date: number | Date | string): string => {
  const i18n = getI18n();
  return dateFormat(date, i18n.t(translations.CleanDateFormat));
};

// https://www.gs1.org/docs/barcodes/GS1_General_Specifications.pdf section 3.4.7
export const getCleanExpiryDate = (
  expiryDate: string,
  ignoreI18N: boolean = false
): string => {
  const i18n = getI18n();
  const format = ignoreI18N
    ? 'mmm dd, yyyy'
    : i18n.t(translations.ShortenedExpiryDateFormat);

  try {
    const year = 2000 + parseInt(expiryDate.substring(0, 2), 10);
    let month = parseInt(expiryDate.substring(2, 4), 10);
    const day = parseInt(expiryDate.substring(4, 6), 10);

    if (month === 0) {
      month = 1;
    }

    if (day !== 0) {
      month--;
    }

    return dateFormat(new Date(year, month, day), format);
  } catch {
    // TODO: figure out how we can use logger here without Nightwatch complaining (#29119)
    // logger.error(new Error('Error parsing the expiryDate: ' + expiryDate), 'date-helper.getCleanExpiryDate');
    return expiryDate;
  }
};

export const convertMsStringToSeconds = (time: string | null): number => {
  if (!time) {
    return 0;
  }

  return parseFloat(time) / 1000;
};

export const convertMsToSeconds = (time: number): number => {
  return time / 1000;
};



// WEBPACK FOOTER //
// ./src/helpers/date-helper.ts